import { ColumnDef } from '@tanstack/react-table';
import { Pencil, Trash2 } from 'lucide-react';
import { DataTableColumnHeader } from '@/components/core';
import { Button } from '@/components/ui-kit/button';
import { NocType } from '../../types/noc-type.types';

interface CreateNocTypeTableColumnsProps {
  t: (key: string) => string;
  onEdit: (nocType: NocType) => void;
  onDelete: (nocType: NocType) => void;
  canUpdate?: boolean;
  canDelete?: boolean;
}

export const createNocTypeTableColumns = ({
  t,
  onEdit,
  onDelete,
  canUpdate = true,
  canDelete = true,
}: CreateNocTypeTableColumnsProps): ColumnDef<NocType>[] => [
  {
    id: 'Name',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('NAME')} />,
    accessorFn: (row) => row.Name ?? '',
    cell: ({ row }) => <span className="truncate font-medium">{row.original.Name}</span>,
  },
  ...(canUpdate || canDelete
    ? [
        {
          id: 'actions',
          // Card: top right, as the old portal's card header.
          meta: { mobile: 'badge' as const },
          header: () => <span className="text-xs font-medium">{t('ACTION')}</span>,
          enableSorting: false,
          enableHiding: false,
          cell: ({ row }: { row: { original: NocType } }) => (
            <div className="flex items-center gap-1">
              {canUpdate && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onEdit(row.original)}
                  aria-label={t('EDIT')}
                >
                  <Pencil className="size-4" />
                </Button>
              )}
              {canDelete && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onDelete(row.original)}
                  aria-label={t('DELETE')}
                >
                  <Trash2 className="size-4" />
                </Button>
              )}
            </div>
          ),
        },
      ]
    : []),
];
